import React from 'react';

import SubMenuChatItems from './SubMenuChatItems';
import SubMenuVoiceItems from './SubMenuVoiceItems';

const SubMenuItems = ({
  handleDragStart,
  handleDragEnd,
  draggingType,
  isActive,
  isBlocos,
  clickTypeBlocos,
  botType,
}) => {
  return (
    <>
      {botType === 'voice' ? (
        <SubMenuVoiceItems
          handleDragStart={handleDragStart}
          handleDragEnd={handleDragEnd}
          draggingType={draggingType}
          isActive={isActive}
        />
      ) : (
        <SubMenuChatItems
          handleDragStart={handleDragStart}
          handleDragEnd={handleDragEnd}
          draggingType={draggingType}
          isActive={isActive}
          isBlocos={isBlocos}
          clickTypeBlocos={clickTypeBlocos}
        />
      )}
    </>
  );
};

export default SubMenuItems;
